module.exports = __webpack_public_path__ + "img/20210730_121424.2222ec0d.jpg";